import {  apiToken, callDetailWithId, callStatsUrl, getOutbondCallURL } from "../config";

// End reason call on Home section
export const endedCallReason = (data) => {
    let totalCountOfCustomerEndedCall = 0;
    let errorAssistantDidNotReceive = 0;
  
    data.forEach(item => {
      if (item.endedReason === "customer-ended-call") {
        totalCountOfCustomerEndedCall += 1;
      } else {
        errorAssistantDidNotReceive += 1;
      }
    });
    const total = totalCountOfCustomerEndedCall + errorAssistantDidNotReceive;
    const customerEndedCallPercent = ((totalCountOfCustomerEndedCall / total) * 100);
    const assistantErrorPercent = ((errorAssistantDidNotReceive / total) * 100);
  
    return {
      customerEndedCallPercent: customerEndedCallPercent,
      assistantErrorPercent: assistantErrorPercent
    };
  };
// End reason call on Home section ended

// Total Call minutes on Home section
export const totalCallsMinutes = async (backendURL, apiToken, startDate, endDate) => {
    try {
      const res = await fetch(backendURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiToken}`,
        },
        body: JSON.stringify({
          startDate: startDate,
          endDate: endDate,
          step: "day",
        }),
      });
  
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
  
      const data = await res.json();
      const duration =
        data?.analytics?.[2]?.result?.[0]?.sumDuration ?? 0;

  
      const roundedDuration = Math.round(duration * 10) / 10;
      return roundedDuration;
    } catch (err) {
      console.error("Failed to fetch numbers of calls:", err);
      return 0;
    }
  };


// Total Call minutes on Home section ended

// total number of call in Home section
 export  const totalNumberOfCalls = async (backendUrl, apiToken, startDate, endDate) => {
    try {
      const res = await fetch(backendUrl, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiToken}`
        },
        body: JSON.stringify({
          startDate: startDate,
          endDate: endDate,
          step: "day",
        })
      })
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const data  = await res.json();
      const numberOfCalls = data['analytics'][3]['result'][0]['countId'];
      return numberOfCalls;
    } catch(err) {
      console.error(err);
    }
  }
// total number of call in Home section ended

// to fetch all call details 
// this will depricate as soon as conversation page is removed
  export const fetchCallDetails = async (
    id,
    {
        setIsMessageLoading,
        setRecordingUrl,
        setConversationData,
        setMessageData,
    }
) => {
    const url = `${callDetailWithId}${id}`;

    // const token =
    //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIzMzJmZmY0Zi0zMmI5LTQ3ODMtYTUyYy1iMzVmMWMxYjE3MWEiLCJyb2xlSWQiOiJkZjM3ZGIyNS05MjEwLTRhODgtYjExYi02YzI4ZjIwOWU4MmIiLCJpYXQiOjE3NDQ4ODE5NzgsImV4cCI6MTc0NTQ4Njc3OH0.RgN0pSCtJzuVxvZLq7LIpMakRIMgCKWZ6bby9WA0zxg';

    setIsMessageLoading(true);
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                accept: 'application/json',
                Authorization: `Bearer ${apiToken}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
        }

        const data = await response.json();


        setRecordingUrl(data['calls'][0]['recordingUrl']);


        const filteredMessages = data.calls[0].messages.filter(
            (msg) =>
                msg.message &&
                msg.message.trim() !== '' &&
                (msg.role === 'user' || msg.role === 'bot')
        );

        setConversationData(data);
        setMessageData(filteredMessages);
    } catch (error) {
        console.error('Failed to fetch call details:', error);
        setMessageData([]);
    } finally {
        setIsMessageLoading(false);
    }
};

// to fetch all call details ended
// to fetch all call details 
export const fetchCallDetailsWithId = async (
  id
) => {
  const url = `${callDetailWithId}${id}`;

  // const token =
  //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIzMzJmZmY0Zi0zMmI5LTQ3ODMtYTUyYy1iMzVmMWMxYjE3MWEiLCJyb2xlSWQiOiJkZjM3ZGIyNS05MjEwLTRhODgtYjExYi02YzI4ZjIwOWU4MmIiLCJpYXQiOjE3NDQ4ODE5NzgsImV4cCI6MTc0NTQ4Njc3OH0.RgN0pSCtJzuVxvZLq7LIpMakRIMgCKWZ6bby9WA0zxg';


  try {
      const response = await fetch(url, {
          method: 'GET',
          headers: {
              accept: 'application/json',
              Authorization: `Bearer ${apiToken}`,
          },
      });

      if (!response.ok) {
          throw new Error(`HTTP error ${response.status}`);
      }

      const data = await response.json();


      return data;
  } catch (error) {
      console.error('Failed to fetch call details:', error);
     
  } 
};

// to fetch all call details ended


// start outbound call
export const getOutbondCall = async (data) => {
  try {
    const response = await fetch(getOutbondCallURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      }, body: JSON.stringify(data)
    });
    const res = await response.json();
    if (!response.ok){
      throw new Error(res.message || 'Network response was not ok')
    }

    return res;
  } catch(e) {
    throw new Error(e.message || 'Failed')
  }
}

// call stats start

export const getCallStats = async () => {
  try {
    const res = await fetch(callStatsUrl, {
      method: "POST",
      headers: {
        'Content-Type' : 'application/json',
        Authorization: `Bearer ${apiToken}`,
      }
    })
    const response = await res.json();

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return response;
  } catch (error) {
    console.error('Failed to fetch call stats:', error);
  }
}

// call stats end